<ng-container *transloco="let t">
  <div class="flex flex-col items-center justify-center p-8 text-center">
    <h2 class="mb-4 text-xl font-semibold text-gray-900">
      {{ t("data-warehouse-activation.activation") }}
    </h2>
    <p class="mb-2 text-sm text-gray-700">
      {{ t("data-warehouse-activation.activation_description") }}
    </p>
    <a href="https://cloud.google.com/bigquery?hl=en" target="_blank" class="text-xs text-blue-600 hover:underline">
      {{ t("data-warehouse-activation.activation_description_link") }}</a
    >
    <div class="mt-6 border-solid border-blue-500">
      <button iButton class="mb-4 w-full px-3 py-2" [label]="" (click)="close()">
        {{ t("data-warehouse-activation.activation_start_trial") }}
      </button>
    </div>
  </div>
</ng-container>
